import { ArrowLeft } from "lucide-react";
import { createMetadata } from "../../lib/seo";

export const metadata = createMetadata({
  title: "增长工作台",
  description: "We0 增长工作台。",
  path: "/workspace",
  keywords: ["We0 增长工作台"],
  noIndex: true,
});

export default function WorkspacePage() {
  return (
    <>
      <a
        href="/"
        aria-label="返回主站"
        title="返回主站"
        style={{
          position: "fixed",
          top: 16,
          left: 16,
          zIndex: 10,
          width: 40,
          height: 40,
          display: "grid",
          placeItems: "center",
          color: "#111",
          background: "rgba(255, 255, 255, 0.92)",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "50%",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
        }}
      >
        <ArrowLeft aria-hidden="true" size={18} />
      </a>
      <iframe
        src="https://growth.we0.ai/"
        title="We0 增长工作台"
        style={{ width: "100%", height: "100dvh", border: 0, display: "block" }}
      />
    </>
  );
}
